import MainPreviewI from '../types.ts';

const start: MainPreviewI['start'] = function () {
    const startPreview = this.startPreview.current!;
    const endPreview = this.endPreview.current!;

    startPreview.addEventListener('ended', () => {
        this.setState({ isLoop: true });

        endPreview.play();

        localStorage.setItem('mainPreviewShow', 'true');
        localStorage.setItem('mainPreviewTime', new Date().getTime().toString());
    });

    setTimeout(() => {
        startPreview.pause();
        startPreview.currentTime = 0;

        endPreview.pause();
        endPreview.currentTime = 0;

        setTimeout(() => {
            startPreview.play();
            this.setState({ isStart: true });
        }, 1_000);
    }, 100);
};

export default start;
